export default __webpack_public_path__ + "static/media/home-community-illus.0b19c4c9.svg";